<template>

    <kt-modal :visible="recordVisible" :title="recordTitle" @dismiss="onDismiss()">
        <template #body>
            <client-form v-model="record"></client-form>
        </template>

        <template #footer>
            <div class="row w-100">
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="onDismiss()" class="btn btn-outline-secondary btn-sm form-control">Close</button>
                </div>
                <div class="col-4" v-if="record.Id">
                    <button @click="deleteRecord()" class="btn btn-outline-danger btn-sm form-control">Delete</button>
                </div>
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="saveRecord()" class="btn btn-outline-primary btn-sm form-control">Save</button>
                </div>
            </div>
        </template>
    </kt-modal>

</template>

<script setup>

import { ref, onMounted, onUpdated } from "vue";
import { useRoute, useRouter } from "vue-router";
import Api from "@/services/Api";
import Alert from "@/services/Alert";
import ClientForm from "@/components/Clients/ClientForm.vue";
import KtModal from "@/components/UI/KtModal.vue";
import { useClientStore } from "@/stores/ClientStore";

const route = useRoute();
const router = useRouter();
const recordTitle = ref("Client Entry");
const recordVisible = ref(true);

const newRecord = () => {
    return {
        Company: "",
        Code: "",
        Phone: "",
        ContactInformation: "",
    };
};

const record = ref(newRecord());

const saveRecord = async () => {

    if (!record.value.Company)
    {
        Alert.notify({
            text: "Please enter a company name."
        });
        return;
    }

    if (!record.value.Code)
    {
        Alert.notify({
            text: "Please enter a company code."
        });
        return;
    }

    let pay = record.value;
    await Api.saveClient(pay);


    let clients = useClientStore();
    await clients.reload();

    router.push({
        path: "/client/list"
    });
};

const deleteRecord = async () => {
    Alert.notify({
        text: "Deletion is currently disabled"
    });
};

const onDismiss = () => {
    router.push({
        path: "/client/list"
    });
};

onMounted(async () => {
    switch (route.params.id) {
        case "new":

            record.value = newRecord();
            break;

        default:

            let rec = await Api.loadClient(route.params.id);

            record.value = rec;

            break;
    }
});

</script>